import { nanoid } from '@lighthouse/tools'
import { mergeDeepRight } from 'rambda'

import type { PageAbstract } from '../abstracts'
import { PageOpenType } from '../abstracts'

export function PageStruct(initial: Partial<PageAbstract> = {}): PageAbstract {
    const id = nanoid(32)
    const DEFAULT_VALUE: PageAbstract = {
        id,
        route: id,
        name: '新页面',
        open: PageOpenType.all,
        isHome: false,
        roleIds: [],
        departmentIds: [],
        language: '',
        collectEvents: [],
        isShowNavbar: true,
        isShowTabBar: true,
        breakPoint: {
            id: 'desktop',
            size: {
                width: {
                    size: 100,
                    unit: '%'
                },
                maxWidth: {
                    size: 1200,
                    unit: 'px'
                },
                height: {
                    size: 'fill'
                },
                minHeight: {
                    size: 100,
                    unit: '%'
                },
                overflow: 'auto'
            },
            layout: {
                align: {
                    direction: 'vertical',
                    isDistributedAlignment: false,
                    /**
                     * 对齐方式
                     */
                    alignX: 'flex-start',
                    alignY: 'flex-start'
                },
                gap: {
                    size: 8,
                    unit: 'px'
                },
                padding: { size: [24, 24, 24, 24], unit: 'px' }
            }
        },
        breakPoints: [
            {
                id: 'mobile'
            }
        ]
    }
    return mergeDeepRight(DEFAULT_VALUE, initial)
}
